import { render, staticRenderFns } from "./newCompraCerdo.vue?vue&type=template&id=40d99338"
import script from "./newCompraCerdo.vue?vue&type=script&lang=js"
export * from "./newCompraCerdo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports